/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  NetworkIngress,
  NetworkIngress$inboundSchema,
} from "./networkingress.js";

/**
 * The organization's active private network ingress, when configured.
 */
export type NetworkIngressResult = {
  ingress?: NetworkIngress | undefined;
};

/** @internal */
export const NetworkIngressResult$inboundSchema: z.ZodMiniType<
  NetworkIngressResult,
  unknown
> = z.object({
  ingress: z.optional(NetworkIngress$inboundSchema),
});

export function networkIngressResultFromJSON(
  jsonString: string,
): SafeParseResult<NetworkIngressResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => NetworkIngressResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'NetworkIngressResult' from JSON`,
  );
}
